import { Skeleton, Stack, SxProps } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell, CellFrame } from '@/core/architecture'

type PostDetailBoxSkeletonProps = {
  sx?: SxProps
}

export const PostDetailBoxSkeleton: Cell<PostDetailBoxSkeletonProps> = ({
  sx,
}) => (
  <CellFrame sx={{ ...sx }}>
    <Skeleton variant="rectangular" width="100%" height={266} />
    <Stack spacing={4} sx={{ px: 5, pt: 5, pb: 8 }}>
      <Stack direction="row" flex={1} spacing={2} alignItems="center">
        <Skeleton variant="circular" width={28} height={28} />
        <SkeletonText variant="small" width="25%" />
      </Stack>
      <Stack sx={{ pb: 7 }}>
        <SkeletonText variant="medium" numberOfLine={3} lastWidth="75%" />
      </Stack>
    </Stack>
  </CellFrame>
)
